import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet'; // Import Helmet
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import Home from './Components/Home';
import About from './Components/About';
import Services from './Components/Services';
import Portfolio from './Components/Portfolio';
import Blog from './Components/Blog';
import Contact from './Components/Contact';
import WebDesign from './Components/WebDesign';
import WebDeveloping from './Components/WebDeveloping';
import WebApplication from './Components/WebApplication';
import SocialMedia from './Components/SocialMedia';
import GraphicDesign from './Components/GraphicDesign';
import MobileSolutions from './Components/MobileSolutions';
import Branding from './Components/Branding';
import Consulting from './Components/Consulting';
import Software from './Components/Software';
import Optimization from './Components/Optimization';
import BlobPlugin from './Components/BlobPlugin';
import DigitalMarketing from './Components/DigitalMarketing';
import BlogWebDevelopment from './Components/BlogWebDevelopment';
import BlogGraphicDesigning from './Components/BlogGraphicDesigning';
import BlogSocialMedia from './Components/BlogSocialMedia';
import BlogDigitalServices from './Components/BlogDigitalServices';
import BlogWebsiteDevelopment from './Components/BlogWebsiteDevelopment';
import BlogAIDigitalMarketing from './Components/BlogAIDigitalMarketing';
import BlogWebsiteDevelopmentCompanies from './Components/BlogWebsiteDevelopmentCompanies';
import BlogReactBestPractices from './Components/BlogReactBestPractices';
import BlogUIUXDesignPrinciples from './Components/BlogUIUXDesignPrinciples';
import BlogEcommerceWebsiteDevelopmentServices from './Components/BlogEcommerceWebsiteDevelopmentServices';
import BlogBestPlatformsForHiringWebsiteDevelopers from './Components/BlogBestPlatformsForHiringWebsiteDevelopers';


function App() {
  return (
    <Router>
      {/* Default Helmet for fallback meta tags */}
      <Helmet>
        <title>Dot Local Host - Web Development & Hosting Solutions</title>
        <meta
          name="description"
          content="Explore DotLocalHost for expert web development, reliable hosting, and innovative digital solutions tailored to your needs. Build your online presence today!"
        />
      </Helmet>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/web-designing" element={<WebDesign />} />
        <Route path="/web-developing" element={<WebDeveloping />} />
        <Route path="/web-application" element={<WebApplication />} />
        <Route path="/social-media" element={<SocialMedia />} />
        <Route path="/graphic-design" element={<GraphicDesign />} />
        <Route path="/mobile-solutions" element={<MobileSolutions />} />
        <Route path="/branding" element={<Branding />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/software" element={<Software />} />
        <Route path="/optimization" element={<Optimization />} />
        <Route path="/blob-plugin" element={<BlobPlugin />} />
        <Route path="/digital-marketing" element={<DigitalMarketing />} />
        <Route path="/blog:webdevelopment" element={<BlogWebDevelopment />} />
        <Route path="/blog:graphic-designing" element={<BlogGraphicDesigning />} />
        <Route path="/blog:social-media-marketing" element={<BlogSocialMedia />} />
        <Route path="/blog:digital-services" element={<BlogDigitalServices />} />
        <Route path="/blog:website-development" element={<BlogWebsiteDevelopment />} />
        <Route path="/blog:ai-digital-marketing-strategies-2025" element={<BlogAIDigitalMarketing />} />
        <Route path="/blog:website-development-companies" element={<BlogWebsiteDevelopmentCompanies />} />
        <Route path="/blog:react-best-practices-for-modern-web-applications" element={<BlogReactBestPractices />} />
        <Route path="/blog:ui-ux-principles" element={<BlogUIUXDesignPrinciples />} />
        <Route path="/blog:ecommerce-website-development-services" element={<BlogEcommerceWebsiteDevelopmentServices />} />
        <Route path="/blog:hiring-best-website-developers-platforms" element={<BlogBestPlatformsForHiringWebsiteDevelopers />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;